import './style.css';
import { renderAccueil } from './views/accueil.ts';
import { renderVocabulaire } from './views/vocabulaire.ts';
import { renderGrammaire } from './views/grammaire.ts';
import { renderPrononciation } from './views/prononciation.ts';
import { renderEcoute } from './views/ecoute.ts';
import { renderTache } from './views/tache.ts';
import { renderAcquis } from './views/acquis.ts';
import { renderParcours } from './views/parcours.ts';
import { renderParametres, applyTheme } from './views/parametres.ts';
import { renderSidebar } from './views/sidebar.ts';
import { renderAside } from './views/aside.ts';
import type { Route } from './router.ts';
import { currentRoute, onRouteChange } from './router.ts';
import { loadSettings, onSettingsChange } from './data/stores.ts';

const app = document.getElementById('app');
if (!app) throw new Error('Missing #app root');

const VIEW: Record<Route, () => HTMLElement> = {
  accueil:       renderAccueil,
  parcours:      renderParcours,
  vocabulaire:   renderVocabulaire,
  grammaire:     renderGrammaire,
  prononciation: renderPrononciation,
  ecoute:        renderEcoute,
  tache:         renderTache,
  acquis:        renderAcquis,
  parametres:    renderParametres,
};

function render(route: Route): void {
  app!.innerHTML = '';
  app!.append(renderSidebar(route));

  const main = document.createElement('main');
  main.className = 'p-8 overflow-y-auto';
  main.style.gridArea = 'main';
  main.append(VIEW[route]());
  app!.append(main);

  app!.append(renderAside(route));
}

// Bootstrap: apply persisted theme + listen for changes, then render.
loadSettings().then((s) => {
  applyTheme(s.theme);
  render(currentRoute());
}).catch(() => {
  render(currentRoute());
});

onSettingsChange((s) => {
  applyTheme(s.theme);
  // Sidebar shows current dialect; cheapest path is to re-render the current view.
  render(currentRoute());
});

onRouteChange(render);

// Register the service worker in production builds. Skipped in dev because
// Vite handles HMR and SW caching gets in the way of editing-then-reload.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('SW registration failed:', err);
    });
  });
}
